<template lang="pug">
    .component-card-smart-edit
        smart-edit(:options="options", :value="item", @input="updateFields")
        button.button.expanded(v-on:click="edit") Save and Submit
</template>
<script type="text/babel">
    import SmartEdit from "components/structure/SmartEdit"
    import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
    import MaggieHelper from "src/maggieHelper";

    export default{
        name: "CardSmartEdit",
        components: {SmartEdit},
        data(){
            return {
                options: {
                    translations: {},
                    types: {
                        enabled: [true, false],

                    },
                    disabled: [
                        "id",
                    ],
                    list: [
                        "id",
                        "driver",
                        "uid",
                    ],
                    listMode: 'blacklist',
                }
            }
        },
        created() {
        },
        methods: {
            updateFields(item){
                this.item = item
            },
            edit(){

                KeplerBackofficeSdk.cards.select(this.item.id).edit(this.item, (response) => {
                    MaggieHelper.notification('edit-esit', 'Card edited successfully');
                    location.reload()
                })
            }
        },
        props: [
            'item'
        ]
    }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>


// WEBPACK FOOTER //
// CardEdit.vue?96f4f950